export function hasMessage(err: any): err is { message: string } {
  return !!err && 'message' in err;
}
